import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../../core/services/auth/auth.service';
import { MessagePopupComponent } from '../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../core/../core/services/popup/popup.service';

@Injectable({
  providedIn: 'root'
})

export class SubscriptionService {

  private url = environment.do_services_sb_url;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  private getSubDetailsUrl = 'userDetails/getSubscriptionDetails';

  constructor(private http: HttpClient, private authService: AuthService,
              private popupService: PopupService, private route: Router) { }

  getSubscriptionDetails(userRequest: string): Observable<any> {
    const options = {
      headers: this.headers
    }
    return this.http.post(this.url + this.getSubDetailsUrl, userRequest, { responseType: 'text' })
      .pipe(
        map((response: any) => {
          const run = response;
          return run;
        }),
        catchError((e: any) => this.handleError(e))
      );
  }

  private handleError(error: any): Observable<never> {
    if([400, 403, 404, 405, 500, 502, 503, 504].includes(error.status)) {
      return throwError(() => error);
    }
    if(error.status === 401) {
			const dialogRef = this.popupService.openDialog(MessagePopupComponent, {
				data: { message: 'Unauthorized Request - Your Session has expired' }
			});
			dialogRef.afterClosed().subscribe(() => {
				this.authService.logout().subscribe(() => {
					this.route.navigate(['/home']);
				});
			});
			return throwError(() => new Error('Unauthorized Request - Session expired'));
		}
    return throwError(() => new Error(`Unhandled status code: ${error.status}`));
  }

}